import React from "react";
import styled from "styled-components";

const MyDiv = styled.div`
  .optionClass {
    color: #f2f2f2;
    background: #121d40;
    font-size: 120%;

    &:checked {
      background: #f2f2f2 !important;
      color: #121d40 !important;
    }
  }

  margin-bottom: 25px;
  @media screen and (max-width: 575px) {
    margin-bottom: 20px;
  }
  > label {
    display: block;
    width: 100%;
    margin-bottom: 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #f2f2f2;
    > .impStar {
      color: red;
      font-size: 18px;
    }
    @media screen and (max-width: 575px) {
      font-size: 13px;
    }
  }
  > select {
    cursor: pointer;
    display: block;
    width: 100%;
    height: 50px;
    background: linear-gradient(
      115.85deg,
      rgba(255, 255, 255, 0.4) -185.19%,
      rgba(255, 255, 255, 0) 129.07%
    );
    backdrop-filter: blur(21px);
    border-radius: 4px;
    border: none;
    outline: none;
    box-sizing: border-box;
    padding: 10px;
    color: #a9b5bb;
    font-size: 14px;
    @media screen and (max-width: 575px) {
      height: 40px;
    }
  }
`;

const CustomSelect = ({
  label,
  name,
  onChange,
  optionArray,
  impStar,
  value,
  readOnly,
  placeholder,
  classStyle,
  borderColor,
  fullWidth,
}) => {
  return (
    <MyDiv className="myInput" style={{ width: fullWidth ? "100%" : "" }}>
      <label>
        {label} {impStar && <abbr className="impStar">{impStar}</abbr>}
      </label>
      <select
        className={classStyle}
        name={name}
        id=""
        readOnly={readOnly}
        disabled={readOnly ? true : false}
        value={value}
        onChange={onChange}
        style={{ border: borderColor && `1px solid ${borderColor}` }}
      >
        <option className="optionClass" value="">
          {placeholder ? placeholder : "Select One Option"}
        </option>
        {optionArray &&
          optionArray?.map((item, idx) => (
            <option
              className="optionClass"
              key={idx}
              value={item.value ? item.value : item.option}
            >
              {item.option}
            </option>
          ))}
      </select>
    </MyDiv>
  );
};

export default CustomSelect;
